import { UserFriendlyNoteFailedReason } from '@heidi/schema/ml-scribe';
import { z } from 'zod';

export const NOTE_GENERATION_OUTCOME_CAPABILITY = 'note_generation_outcome_v1';

const failureSchema = z.object({
  failure_reason: z.nativeEnum(UserFriendlyNoteFailedReason).nullable(),
  should_retry: z.boolean(),
});

export type NoteGenerationFailureFrame = z.infer<typeof failureSchema>;

export function tryHandleNoteGenerationFailedEvent(
  event: { event?: string; data: string },
  onFailure?: (frame: NoteGenerationFailureFrame) => void
): boolean {
  if (event.event !== 'note_generation_failed') return false;

  let payload: unknown;
  try {
    payload = JSON.parse(event.data);
  } catch {
    payload = undefined;
  }
  const parsed = failureSchema.safeParse(payload);
  // A recognized control frame is terminal even when its payload is invalid.
  // Only validated fields leave the parser; malformed frames never become text.
  onFailure?.(
    parsed.success ? parsed.data : { failure_reason: null, should_retry: false }
  );
  return true;
}
